import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static values = {
    targetText: String,
    animation: String
  }

  static targets = ['button']

  connect() {}

  copy(event) {
    event.preventDefault()
    navigator.clipboard.writeText(this.targetTextValue)
    if (this.hasButtonTarget) {
      let animation = this.animationValue || 'animate__heartBeat'
      this.buttonTarget.classList.add('animate__animated', animation)
      this.buttonTarget.addEventListener('animationend', () => {
        this.buttonTarget.classList.remove(animation)
      })
    }
  }
}
